class BffApiUrlService {

    constructor() {
        this.baseUrl = process.env.MIX_APP_URL || 'https://account.amplify.localhost';
    }

    getOrganizationUsersListEndpoint() {
        return `${this.baseUrl}/bff/webapp/organization/users`;
    }

    getEditUserEndpoint(userId) {
        return `${this.baseUrl}/bff/webapp/organization/user/${userId}`;
    }

    getOrganizationFilterableModulesEndpoint() {
        return `${this.baseUrl}/bff/webapp/organization/modules/filterable`;
    }

    getMyProfileEndpoint(userId) {
        return `${this.baseUrl}/bff/webapp/user/${userId}/myprofile`;
    }
}

const bffApiUrlService = new BffApiUrlService();
export default bffApiUrlService;
